import React, { useState } from 'react';
import { DatePickerComponent, ChangeEventArgs } from '@syncfusion/ej2-react-calendars';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { Button, Modal } from 'react-bootstrap';
import { get } from 'lodash';
import { useFormContext, Controller } from 'react-hook-form';

interface IInputProps {
  name: string;
  id: string;
  label?: string;
  placeholder?: string;
  modal?: string;
  minDate?: Date;
  maxDate?: Date;
  req?: any;
  disableDate?: boolean;
  getDayWeek?: (date: Date) => void;
  xl?: number;
  md?: number;
  col?: number;
}

const FormInputYear: React.FC<IInputProps> = ({
  name,
  id,
  label,
  placeholder,
  getDayWeek,
  minDate,
  maxDate,
  req,
  disableDate,
  modal,
  xl = 12,
  md = 12,
  col = 12,
}) => {
  const {
    control,
    formState: { errors }
  } = useFormContext();

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const errorMessage = get(errors, name)?.message as string | undefined;

  return (
    <div className={`col-xl-${xl} col-md-${md} col-${col}`}>
      <div className={`input-block ${id} ${errorMessage ? 'error' : ''}`}>
        {label && (
          <label htmlFor={id} className="input-block__label">
            {label}
          </label>
        )}

        {modal && (
          <TooltipComponent content="Más información">
            <div onClick={handleShow} className="information-icon-orange p-0" />
          </TooltipComponent>
        )}

        <Controller
          name={name}
          control={control}
          rules={{ required: req }}
          render={({ field: { value, onChange } }) => (
            <DatePickerComponent
              id={id}
              format="yyyy"
              firstDayOfWeek={1}
              start="Decade"
              depth="Decade"
              disabled={disableDate}
              min={minDate}
              max={maxDate}
              placeholder={placeholder}
              value={value ? new Date(value, 0, 1) : null}
              change={({ value: date }: ChangeEventArgs) => {
                const year = date instanceof Date ? date.getFullYear() : null;
                onChange(year);
                if (getDayWeek && date instanceof Date) getDayWeek(date);
              }}
            />
          )}
        />

        {errorMessage && <p className="error m-0">{errorMessage}</p>}

        {/* Modal informativo */}
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{label}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{modal}</Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default FormInputYear;
